export default "__VITE_ASSET__fde1475a__"